import { render, staticRenderFns } from "./InterviewGrade.vue?vue&type=template&id=25fa1387&scoped=true"
import script from "./InterviewGrade.vue?vue&type=script&lang=js"
export * from "./InterviewGrade.vue?vue&type=script&lang=js"
import style0 from "../../statistics/css/interviewGrade.css?vue&type=style&index=0&id=25fa1387&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa1387",
  null
  
)

export default component.exports